import JSZip from "jszip";

export const unzipZipFile = async (zipBlob: Blob) => {
  const zip = await JSZip.loadAsync(zipBlob);

  const extractedFiles: {
    fileName: string;
    file: File;
  }[] = [];

  for (const fileName in zip.files) {
    const zipEntry = zip.files[fileName];

    if (!zipEntry.dir) {
      const fileData = await zipEntry.async("arraybuffer");

      let mimeType = "";
      if (fileName.endsWith(".pdf")) mimeType = "application/pdf";
      else if (fileName.endsWith(".png")) mimeType = "image/png";
      else if (fileName.endsWith(".jpg") || fileName.endsWith(".jpeg"))
        mimeType = "image/jpeg";

      const file = new File([fileData], fileName, { type: mimeType });

      extractedFiles.push({
        fileName,
        file,
      });
    }
  }

  return extractedFiles;
};
